import React from 'react';
import PublicHeader from '../parts/PublicHeader';
import SiteMainArea from '../parts/SiteMainArea';

const Step1: React.FC = () => {
  return (
    <>
      <PublicHeader />
      <SiteMainArea>
        <div className="register-box__title">
          河合塾One個人向けサービスは、新規受付を終了しました
        </div>
      </SiteMainArea>
    </>
  );
};

export default Step1;